import api from "./axios";

export type ProfitMarginType = "FLAT" | "PERCENTAGE";
export type ProfitMarginDirection = "onRamp" | "offRamp";

export type ProfitMarginDirectionConfig = {
  provider: "quidax" | "treasura";
  marginType: ProfitMarginType;
  marginValue: string;
  providerRate: string | null;
  customerRate: string | null;
  asOf: string | null;
};

export type ProfitMarginConfiguration = {
  onRamp: ProfitMarginDirectionConfig;
  offRamp: ProfitMarginDirectionConfig;
  version: number;
  updatedAt: string;
  updatedBy: string | null;
};

export type ProfitMarginInput = {
  marginType: ProfitMarginType;
  marginValue: string;
};

export type ProfitMarginUpdate = Partial<
  Record<ProfitMarginDirection, ProfitMarginInput>
> & { version: number };

export type ProfitMarginPreview = {
  current: ProfitMarginConfiguration;
  proposed: ProfitMarginConfiguration;
  valid: boolean;
  errors: Partial<Record<ProfitMarginDirection, string>>;
  previewedAt: string;
};

type ApiEnvelope<T> = {
  status: boolean;
  message: string;
  data: T;
};

const profitMarginEndpoint = "/merchant/market-setting/profit-margin";

export async function getProfitMargins(): Promise<ProfitMarginConfiguration> {
  const response =
    await api.get<ApiEnvelope<ProfitMarginConfiguration>>(profitMarginEndpoint);
  return response.data.data;
}

export async function previewProfitMargins(
  payload: Partial<Record<ProfitMarginDirection, ProfitMarginInput>>,
  signal?: AbortSignal,
): Promise<ProfitMarginPreview> {
  const response = await api.post<ApiEnvelope<ProfitMarginPreview>>(
    `${profitMarginEndpoint}/preview`,
    payload,
    { signal },
  );
  return response.data.data;
}

export async function updateProfitMargins(
  payload: ProfitMarginUpdate,
): Promise<ProfitMarginConfiguration> {
  const response = await api.patch<ApiEnvelope<ProfitMarginConfiguration>>(
    profitMarginEndpoint,
    payload,
  );
  return response.data.data;
}
